/**
 * @generated SignedSource<<e622aaae5450b8d05a6ab8dfc7c976ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useHardwareTypesRelayQuery$variables = {
  first?: number | null | undefined;
};
export type useHardwareTypesRelayQuery$data = {
  readonly listHardwareTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
      };
    }> | null | undefined;
  } | null | undefined;
};
export type useHardwareTypesRelayQuery = {
  response: useHardwareTypesRelayQuery$data;
  variables: useHardwareTypesRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Literal",
        "name": "sort",
        "value": [
          {
            "field": "NAME",
            "order": "ASC"
          }
        ]
      }
    ],
    "concreteType": "HardwareTypeConnection",
    "kind": "LinkedField",
    "name": "listHardwareTypes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HardwareTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareTypesRelayQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHardwareTypesRelayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "240c91fbc7d45b79bada43b812463fbe",
    "id": null,
    "metadata": {},
    "name": "useHardwareTypesRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareTypesRelayQuery(\n  $first: Int\n) {\n  listHardwareTypes(first: $first, sort: [{field: NAME, order: ASC}]) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5f167885b0d5771e38e53c59c68c293";

export default node;
